import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { Container, Image, CreatedAt, SeeProject, Situation } from './styles';

const propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
    images: PropTypes.arrayOf(PropTypes.object).isRequired,
    name: PropTypes.string.isRequired,
    situation: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
};

const DesignerProjectCard = ({ project }) => {
  const history = useHistory();
  let situationTagColor;
  let situationTextColor;

  // Cores de status vêm dos tokens semânticos para funcionarem nos dois temas.
  switch (project.situation) {
    case 'Aprovado':
      situationTagColor = 'var(--success-tint)';
      situationTextColor = 'var(--success)';
      break;

    case 'Verificar':
      situationTagColor = 'var(--danger-tint)';
      situationTextColor = 'var(--danger)';
      break;

    case 'Em análise':
      situationTagColor = 'var(--laranja-tint)';
      situationTextColor = 'var(--laranja)';
      break;

    default:
      situationTagColor = 'var(--surface-2)';
      situationTextColor = 'var(--ink-faint)';
  }

  function handleSeeProjectClick() {
    history.push(`/designer/projects/${project.id}`);
  }

  return (
    <Container>
      <Image src={project.images[0] ? project.images[0].url : ''} alt="" />
      <div>
        <h2>{project.name}</h2>
        <Situation tagColor={situationTagColor} textColor={situationTextColor}>
          <p>{project.situation}</p>
        </Situation>

        <CreatedAt>{`Criado em ${project.createdAt}`}</CreatedAt>
        <SeeProject onClick={handleSeeProjectClick}>Ver projeto</SeeProject>
      </div>
    </Container>
  );
};

DesignerProjectCard.propTypes = propTypes;

export default DesignerProjectCard;
